/**
 * Desktop Linux web (Brave / Chromium / Firefox / Waterfox), not Android or
 * ChromeOS. Used to tighten chat list virtualization where software compositing
 * turns RN-web's View tree into 500–800MB tabs. Mac / Windows / iOS / Android
 * must not take this path — shrinking windowSize there historically left blank
 * gaps in RN-web VirtualizedList.
 */
export function isDesktopLinuxWeb(nav = typeof navigator === 'undefined' ? null : navigator) {
  if (!nav) return false;
  const ua = typeof nav.userAgent === 'string' ? nav.userAgent : '';
  if (/Android|CrOS|iPhone|iPad|iPod/i.test(ua)) return false;
  const platformHint = nav.userAgentData?.platform || nav.platform || '';
  if (/Linux/i.test(platformHint)) return true;
  return /Linux/i.test(ua);
}

// Brave uses Chromium's UA; do not depend on its optional navigator.brave API.
export function isDesktopLinuxChromiumWeb(nav = typeof navigator === 'undefined' ? null : navigator) {
  return isDesktopLinuxWeb(nav) && (
    /\b(?:Chrome|Chromium)\/\d/.test(nav?.userAgent || '')
    || (nav?.userAgentData?.brands || []).some(({ brand }) => /^(Chromium|Google Chrome|Brave)$/.test(brand))
  );
}
